import React, { Component } from 'react';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/styles';
import { StyledEngineProvider, Theme } from '@mui/material/styles';
import Dashboard from '../views/DashboardLayout/DashboardLayout';
import Registration from '../auth/Registration/Registration';
import Login from '../auth/Login/Login';
import LoginNew from '../auth/Login/LoginNew';
import ForgotPassword from '../auth/ForgotPassword/ForgotPassword';
import ForgotPasswordNew from '../auth/ForgotPassword/ForgotPasswordNew';
import routes from '../constants/Routes';
import theme from '../theme';
import AlertBox from 'views/Common/AlertBox';
import AssertionPopup from 'views/Common/AssertionPopup';
import ProgressCircular from 'views/Common/CircularProgress';
import ResetPassword from 'views/UserProfile/ResetPassword';

declare module '@mui/styles/defaultTheme' {
	interface DefaultTheme extends Theme {}
}
class RoutesConfiguration extends Component {
	render() {
		return (
			<div>
				<CssBaseline />
				<StyledEngineProvider injectFirst>
					<ThemeProvider theme={theme}>
						<AlertBox />
						<AssertionPopup />
						<ProgressCircular />
						<Router>
							<Routes>
								<Route path={routes.LOGIN.path} element={<LoginNew />} />
								<Route
									path={routes.RESET_PASSWORD.path}
									element={<ResetPassword />}
								/>
								<Route
									path={routes.REGISTRATION.path}
									element={<Registration />}
								/>
								<Route
									path={routes.FORGOTPWD.path}
									element={<ForgotPasswordNew />}
								/>
								<Route path={routes.HOME.path} element={<Dashboard />} />
							</Routes>
						</Router>
					</ThemeProvider>
				</StyledEngineProvider>
			</div>
		);
	}
}

export default RoutesConfiguration;
